import Axios from "axios";

const ENDPOINT_URL = process.env.NEXT_PUBLIC_ENDPOINT_URL;

export const axios = Axios.create({
	baseURL: `${ENDPOINT_URL}/api/v1`,
});
